/**
 * Capacitor plugin provides a single and simple interface for accessing fingerprint APIs on both Android 6+ and iOS.
 * Reference docs used to derive types & behavior:
 *   https://www.npmjs.com/package/cordova-plugin-fingerprint-aio
 */

import { BiometryType, RegisterBiometricOptions } from "./types";

class Biometrics {
  private get plugin (): any {
    return (window as any)?.Fingerprint;
  }

  isAvailable (): Promise<BiometryType> {
    return new Promise((resolve, reject) => {
      if (!this.plugin) {
        return resolve(BiometryType.None);
      }

      this.plugin.isAvailable(
        (biometryType: BiometryType) => resolve(biometryType),
        (error: any) => reject(error)
      );
    });
  }

  loadSecret (options: {
    title: string;
    description: string;
    disableBackup: boolean;
  }): Promise<any> {
    return new Promise((resolve, reject) => {
      this.plugin.loadBiometricSecret(
        options,
        (result: string) => {
          if (!result) {
            return reject("EMPTY_SECRET");
          }
          resolve(JSON.parse(result));
        },
        (error: any) => reject(error)
      );
    });
  }

  registerSecret (options: RegisterBiometricOptions): Promise<void> {
    return new Promise((resolve, reject) => {
      this.plugin.registerBiometricSecret(
        options,
        () => resolve(),
        (error: any) => reject(error)
      );
    });
  }
}

export default (new Biometrics());